// extracted by mini-css-extract-plugin
export default {"btn":"CartButton_btn__QPdOh"};